export const compose = (...fns) => (...args) => {
  fns.forEach(fn => fn && fn(...args));
};

export const pick = (obj, ...props) => {
  return props.reduce((newObj, prop) => {
      if (obj.hasOwnProperty(prop)) {
      newObj[prop] = obj[prop];
      }
      return newObj;
  }, {});
};

const getRand = (range) => Math.floor(Math.random() * range);

const genNum = (len) => Array.from({length: len}, () => getRand(9)).join('');

export const genOption = (obj) => {
  const keys = Object.keys(obj);
  const len = keys.length;
  const key = keys[getRand(len)];
  const option = obj[key].key;

  return option;
}

export const genTen = () => genNum(10);

